import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
	name: 'localizedDate',
	pure: false  // required to update the value when currentLang is changed
})
export class LocalizedDatePipe implements PipeTransform {
	private value: string | null;
	private lastDate: any;
	private lastLang: string;
	private lastPattern: string;
	private lastTimezone: string;

	constructor(private translate: TranslateService) { }

	transform(date: any, pattern = 'mediumDate', timezone?: string): any {
		const currentLang = this.translate.currentLang;

		// if we ask another time for the same date & locale, return the last value
		if (date === this.lastDate && currentLang === this.lastLang
			&& pattern === this.lastPattern && timezone === this.lastTimezone) {
			return this.value;
		}

		this.lastDate = date;
		this.lastLang = currentLang;
		this.lastPattern = pattern;
		this.lastTimezone = timezone;

		if (this.isIanaTimeZone(timezone)) {
			this.value = this.formatWithIana(date, pattern, currentLang, timezone);
		} else {
			this.value = new DatePipe(currentLang).transform(date, pattern, timezone);
		}

		return this.value;
	}

	private isIanaTimeZone(timezone?: string): boolean {
		return !!timezone && timezone.includes('/');
	}

	private formatWithIana(date: any, pattern: string, locale: string, timeZone: string): string {
		if (!date) {
			return null;
		}
		return new Intl.DateTimeFormat(locale, {
			...this.patternToIntlOptions(pattern),
			timeZone,
		}).format(new Date(date));
	}

	private patternToIntlOptions(pattern: string): Intl.DateTimeFormatOptions {
		switch (pattern) {
			case 'medium':
				return { dateStyle: 'medium', timeStyle: 'medium' };
			case 'mediumDate':
				return { dateStyle: 'medium' };
			case 'mediumTime':
				return { timeStyle: 'medium' };
			case 'short':
				return { dateStyle: 'short', timeStyle: 'short' };
			case 'shortDate':
				return { dateStyle: 'short' };
			case 'shortTime':
				return { timeStyle: 'short' };
			default:
				return { dateStyle: 'medium', timeStyle: 'short' };
		}
	}
}
